module.exports = __webpack_public_path__ + "static/media/aristamd_search.1dd1d1bf.svg";